<template>
    <div v-if="registration">
        <top-navbar :breadcrumb="breadcrumb"></top-navbar>

        <div class="container-fluid mt--6">
            <div class="row" v-if="registration.status == 'archived'">
                <div class="col-12">
                    <registration-members :registration="registration" :ready="true" @change="changed"></registration-members>
                </div>
            </div>
            <div class="row" v-else>
                <div class="col-6">
                    <platform-users :registration="registration" @ready="usersReady = true" @change="changed"></platform-users>
                </div>
                <div class="col-6">
                    <registration-members :registration="registration" :ready="usersReady" @change="changed"></registration-members>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import PlatformUsers from './registrations/PlatformUsers'
    import RegistrationMembers from './registrations/RegistrationMembers'

    export default {

        components: {
            PlatformUsers, RegistrationMembers
        },

        data() {
            return {
                registration: null,
                usersReady : false,
            }
        },

        computed: {

            breadcrumb() {
                return [
                    {
                        name: this.$t('common.registrations'),
                        route: '/socrates/ui/training/registrations'
                    },
                    {
                        name: this.registration.degree.name + ' / ' + this.registration.cohort.name,
                    },
                ]
            }
        },

        beforeRouteEnter(to, from, next) {
            axios.get('/socrates/api/front/registrations/'+to.params.id, {params: {
                relations: ['cohort', 'degree', 'testers'],
            }})
            .then(resp => {
                next(vm => {
                    vm.registration = resp.data.data
                })
            })
        },

        methods: {
            changed() {
                axios.get('/socrates/api/front/registrations/'+this.$route.params.id, {params: {
                    relations: ['cohort', 'degree', 'testers'],
                }})
                .then(resp => {
                    this.registration = resp.data.data
                })
                .catch(err => {
                    this.$auth.handleErrorVm(err, this)
                })        
            }
        }
    }
</script>
